const GOOD = "var(--status-good)"
const WARN = "var(--status-warn)"
const INFO = "var(--status-info)"
const BAD = "var(--destructive)"
const MUTED = "var(--muted-foreground)"
const STRONG = "var(--foreground)"

const STATUS_DOT: Record<string, string> = {
  accepted: GOOD,
  active: GOOD,
  approved: GOOD,
  on_track: GOOD,
  paid: GOOD,

  at_risk: WARN,
  on_leave: WARN,
  partial: WARN,
  pending: WARN,

  invoiced: INFO,
  sent: INFO,

  behind: BAD,
  overdue: BAD,
  rejected: BAD,
  void: BAD,

  completed: MUTED,
  draft: MUTED,

  converted: STRONG,
}

export function statusDot(status: string | null | undefined): string {
  return STATUS_DOT[status ?? ""] ?? MUTED
}

export function statusLabel(status: string | null | undefined): string {
  return (status ?? "").replace(/_/g, " ")
}
